import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { createPortal } from "react-dom"; // 🔥 Portal import kiya

function LoginSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      localStorage.setItem("homeSideMenu", "Dashboard");
      navigate("/HomePage");
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  // 🔥 Content ko body ke andar directly render karo (bypass App.js wrapper)
  const content = (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 999999,
        display: "flex",
        backgroundColor: "#f9fafb",
        margin: 0,
        padding: 0,
        overflow: "hidden",
      }}
    >
      {/* Left Side - Banner */}
      <div
        className="hidden md:flex w-1/2 items-center justify-center p-8"
        style={{
          background: "linear-gradient(to bottom right, #ffffff, #fff7ed)",
        }}
      >
        <img
          src="/LoginRegister/BannerImg.png"
          alt="banner"
          className="w-full max-w-lg object-contain drop-shadow-xl"
        />
      </div>

      {/* Right Side - Success Message */}
      <div className="flex-1 flex flex-col items-center justify-center p-6 bg-white">
        <div className="flex flex-col items-center text-center p-8 max-w-md w-full rounded-3xl border border-gray-200 bg-gradient-to-b from-white to-orange-50/30 shadow-sm">
          <div className="w-24 h-24 rounded-full bg-green-50 flex items-center justify-center mb-6 shadow-lg shadow-green-500/10">
            <CheckCircle2
              size={56}
              className="text-green-500"
              strokeWidth={2.5}
            />
          </div>

          <h1 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-2 tracking-tight">
            Login Successful!
          </h1>

          <p className="text-sm text-gray-500 mb-8 leading-relaxed">
            Welcome back! You will be redirected to your dashboard in a moment.
          </p>

          <div className="flex items-center gap-3 text-orange-500">
            <svg
              className="animate-spin h-5 w-5 text-orange-500"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            <span className="text-sm font-semibold">Redirecting...</span>
          </div>
        </div>
      </div>
    </div>
  );

  // 🔥 Portal use karke body mein render karo
  return createPortal(content, document.body);
}

export default LoginSuccess;
